export default () => {
  document.querySelectorAll('.error-404__nav-menu').forEach((block) => {
    const menuItemsChildren = block.querySelectorAll('.menu-item-has-children');
    const menuItems = block.children;

    menuItemsChildren.forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        item.classList.toggle('active');
      });
    });

    menuItems.forEach((item) => {
      let cleanTimeout;
      const link = item.children[0];

      item.addEventListener('mouseenter', () => {
        clearTimeout(cleanTimeout);
        item.classList.add('hover-on');
        link.classList.remove('hover-out');
      });

      item.addEventListener('mouseleave', () => {
        item.classList.remove('hover-on');
        link.classList.add('hover-out');

        cleanTimeout = setTimeout(() => {
          link.classList.remove('hover-out');
        }, 450);
      });
    });
  });
};
